import { useState } from 'react';
import { courseModules } from '../../../mocks/courseModules';

export default function ModulesSection() {
  const [openModule, setOpenModule] = useState<number | null>(1);

  const toggleModule = (id: number) => {
    setOpenModule(openModule === id ? null : id);
  };

  const totalLessons = courseModules.reduce((acc, m) => acc + m.lessons.length, 0);

  return (
    <section id="modulos" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-orange-50 text-orange-600 text-sm font-semibold rounded-full mb-4">
            <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
            Conteúdo Completo
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            8 Módulos Detalhados
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            São <strong>{totalLessons} aulas práticas</strong> organizadas em módulos progressivos, do básico ao avançado
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4">
          {courseModules.map((module) => {
            const isOpen = openModule === module.id;
            const isBonus = 'isBonus' in module && module.isBonus;

            return (
              <div
                key={module.id}
                className={`rounded-2xl border-2 transition-all duration-300 overflow-hidden ${
                  isBonus
                    ? 'border-amber-300 bg-gradient-to-r from-amber-50 to-orange-50'
                    : isOpen
                    ? 'border-orange-200 bg-orange-50/30 shadow-lg'
                    : 'border-gray-200 bg-white hover:border-orange-200 hover:shadow-md'
                }`}
              >
                <button
                  onClick={() => toggleModule(module.id)}
                  className="w-full flex items-center gap-4 p-6 text-left cursor-pointer"
                >
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
                    isBonus
                      ? 'bg-gradient-to-br from-amber-400 to-orange-500'
                      : isOpen
                      ? 'bg-gradient-to-br from-orange-500 to-amber-500'
                      : 'bg-gray-100'
                  }`}>
                    <i className={`${module.icon} text-xl ${
                      isBonus || isOpen ? 'text-white' : 'text-gray-600'
                    }`}></i>
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-3 mb-1">
                      {isBonus && (
                        <span className="px-2 py-0.5 bg-amber-500 text-white text-[10px] font-bold rounded-full uppercase tracking-wider">
                          Bônus
                        </span>
                      )}
                      <span className="text-xs text-gray-400 font-medium uppercase tracking-wider">
                        {isBonus ? '' : `Módulo ${String(module.id).padStart(2, '0')}`}
                      </span>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 leading-snug">
                      {module.title}
                    </h3>
                  </div>

                  <div className="flex items-center gap-4 flex-shrink-0">
                    <div className="hidden sm:flex items-center gap-1.5 text-sm text-gray-500">
                      <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                      {module.duration}
                    </div>
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-transform duration-300 ${
                      isOpen ? 'bg-orange-500 rotate-180' : 'bg-gray-100'
                    }`}>
                      <i className={`ri-arrow-down-s-line text-lg ${isOpen ? 'text-white' : 'text-gray-500'}`}></i>
                    </div>
                  </div>
                </button>

                <div className={`transition-all duration-300 ${
                  isOpen ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
                } overflow-hidden`}>
                  <div className="px-6 pb-6">
                    <p className="text-sm text-gray-600 pl-16 leading-relaxed">
                      {module.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
